import {generateContainer, IContainerProps} from "../base/generate-container";
import {changeLanguageAndMarket, setInfoToolbox} from "./settings.actions";
import {ISettingsContainerState} from "./settings";
import {IStoreState} from "@montana/store/store";

const mapState = (state: IStoreState): ISettingsContainerState => ({
    ...state.settings || {}
});

const mapActionsObject = {
    changeLanguageAndMarket,
    setInfoToolbox
};

export type ISettingsContainerProps = IContainerProps<ReturnType<typeof mapState>, typeof mapActionsObject>;

export const [SettingsContainer, connectWithSettings, useSettings] = generateContainer(mapState, mapActionsObject);
